import helpersNumbers from "../helpers/numbers";
export default {
  AMOUNT_IS_LESS: `  حداقل مبلغ مجاز ${helpersNumbers.toPersianNum(
    helpersNumbers.toFormatFinanceNumber(
      process.env.REACT_APP_AT_LEAST_AMOUNT_CHARGE
    )
  )} تومان می باشد. `,

  PAYMENT_FAILED: "پرداخت شما با شکست روبرو شد",
  PAYMENT_SUCCESS: "پرداخت شما با موفقیت انجام شد",
};
